import { RootState } from 'store';

export const selectOrgDashboardData = (state: RootState) => state.orgDashboard.data;
export const selectOrgDashboardLoading = (state: RootState) => state.orgDashboard.loading;
export const selectOrgDashboardError = (state: RootState) => state.orgDashboard.error;
